<!--
 * @Author: mzw
 * @Date: 2021-09-22 15:13:50
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-06-03 09:06:10
 * @Description: 发票编辑弹窗组件
-->
<template>
  <div class="addArea">
    <div class="add_form">
      <el-form
        label-width="110px"
        :model="invoiceForm"
        :rules="invoiceFormRules"
        ref="invoiceForm"
        label-position="right"
      >
        <el-form-item label="发票类型：" prop="invoiceType">
          <el-radio-group v-model="invoiceForm.invoiceType">
            <el-radio label="20">增值税专用发票</el-radio>
            <el-radio label="10">增值税普通发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头" prop="companyName">
          <el-input
            v-model="invoiceForm.companyName"
            :maxlength="40"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="税务登记证号:"
          prop="taxpayerIdentity"
          :rules="
            invoiceForm.invoiceType === '20'
              ? invoiceFormRules.taxpayerIdentity
              : [{ required: false, message: '', trigger: 'blur' }]
          "
        >
          <el-input
            v-model="invoiceForm.taxpayerIdentity"
            maxlength="50"
            placeholder=""
            @input="
              invoiceForm.taxpayerIdentity =
                invoiceForm.taxpayerIdentity.replace(/[^A-Za-z0-9]/g, '')
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          label="开户银行名称:"
          prop="openingBank"
          :rules="
            invoiceForm.invoiceType === '20'
              ? invoiceFormRules.openingBank
              : [{ required: false, message: '', trigger: 'blur' }]
          "
        >
          <el-input
            v-model="invoiceForm.openingBank"
            :maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="基本开户账号:"
          prop="bankAccountNo"
          :rules="
            invoiceForm.invoiceType === '20'
              ? invoiceFormRules.bankAccountNo
              : [{ required: false, message: '', trigger: 'blur' }]
          "
        >
          <el-input
            v-model="invoiceForm.bankAccountNo"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="注册场所地址:"
          prop="companyAddress"
          :rules="
            invoiceForm.invoiceType === '20'
              ? invoiceFormRules.companyAddress
              : [{ required: false, message: '', trigger: 'blur' }]
          "
        >
          <el-input
            v-model="invoiceForm.companyAddress"
            :maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="注册固定电话:"
          prop="companyPhone"
          :rules="
            invoiceForm.invoiceType === '20'
              ? invoiceFormRules.companyPhone
              : [{ required: false, message: '', trigger: 'blur' }]
          "
        >
          <el-input
            v-model="invoiceForm.companyPhone"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否为默认：">
          <el-checkbox v-model="invoiceForm.flagAdd"> 默认发票 </el-checkbox>
        </el-form-item>
      </el-form>
      <div class="save-warp">
        <el-button
          @click="invoiceSaveHandle"
          size="medium"
          type="primary"
          :loading="buttonLoading"
          class="plc-btn"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { taxReg, tellReg } from '@/utils/reg'
export default {
  data () {
    return {
      invoiceForm: {
        invoiceType: '10',
        companyName: '',
        taxpayerIdentity: '',
        openingBank: '',
        bankAccountNo: '',
        companyAddress: '',
        companyPhone: '',
        flagAdd: false
      },
      buttonLoading: false
    }
  },
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  computed: {
    invoiceFormRules () {
      return {
        companyName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        taxpayerIdentity: [
          {
            required: true,
            pattern: taxReg,
            message: '请输入正确的税务登记证号',
            trigger: 'blur'
          }
        ],
        bankAccountNo: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyAddress: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        openingBank: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyPhone: [
          {
            required: true,
            pattern: tellReg,
            message: '请输入正确的注册固定电话',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    if (this.row.invoiceId) {
      this.setData()
    }
  },
  methods: {
    setData () {
      Object.keys(this.invoiceForm).forEach((key) => {
        this.invoiceForm[key] = this.row[key] || ''
      })
      if (this.row.defaultFlag === '1') {
        this.invoiceForm.flagAdd = true
      } else {
        this.invoiceForm.flagAdd = false
      }
    },
    invoiceSaveHandle () {
      this.$refs['invoiceForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    },
    doSave () {
      if (this.buttonLoading) {
        return
      }
      const obj = {
        ...this.invoiceForm,
        invoiceId: this.row.invoiceId || undefined,
        defaultFlag: this.invoiceForm.flagAdd ? '1' : '0'
      }
      this.buttonLoading = true
      const url = this.row.invoiceId ? '/front/consumer/order/payinvoice/update' : '/front/consumer/order/payinvoice/save'
      this.$http
        .post(url, obj)
        .then(({ data: res }) => {
          this.buttonLoading = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.$emit('refreshDataList')
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.save-warp {
  text-align: center;
  margin-top: 20px;
}
</style>
